$(function () {
  function _popover() {
    $('[data-toggle=popover]').popover().on('click', function (e) {
      e.preventDefault();
    });
  }
  $(document).bind('initialize-modal.custom', function () {
    _popover();
  });
  _popover();
});
